import React, { createContext, useContext } from 'react';

import { PublicOfferEntityNormalized } from '../../../../../../../store/product/types';

interface PublicOfferAssetContextReceivedData {}

interface PublicOfferAssetContextData extends PublicOfferAssetContextReceivedData {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  offerSelected: PublicOfferEntityNormalized | undefined;
  setOfferSelected: React.Dispatch<React.SetStateAction<PublicOfferEntityNormalized | undefined>>;
}

interface Props extends PublicOfferAssetContextReceivedData {
  children: React.ReactNode;
}

const PublicOfferAssetContext = createContext<PublicOfferAssetContextData>(
  {} as PublicOfferAssetContextData
);

const PublicOfferAssetProvider: React.FC<Props> = ({ children, ...props }) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [offerSelected, setOfferSelected] = React.useState<PublicOfferEntityNormalized>();

  return (
    <PublicOfferAssetContext.Provider
      value={{
        ...props,
        modalOpen,
        setModalOpen,
        offerSelected,
        setOfferSelected,
      }}>
      {children}
    </PublicOfferAssetContext.Provider>
  );
};

const usePublicOfferAssetContext = (): PublicOfferAssetContextData => {
  const context = useContext(PublicOfferAssetContext);

  if (!context) {
    throw new Error('usePublicOfferAssetContext must be used within an PublicOfferAssetContext');
  }
  return context;
};

export { PublicOfferAssetProvider, usePublicOfferAssetContext, PublicOfferAssetContextData };
